'use client';
import { Button as SharedButton } from '@launchstore/shared-puck';
import type { ButtonProps } from '@launchstore/shared-puck';
export const Button: any = SharedButton;
export type { ButtonProps };
export default Button;
